import { useState, useEffect } from "react";
import { AnnouncementProps } from "@/interfaces/announcement_types";

type AnnouncementCardProps = {
    announcement: AnnouncementProps,
    isNew: boolean,
    onView: () => void
}

export function AnnouncementCard({ announcement, isNew, onView }: AnnouncementCardProps) {
    const [isNewLocal, setIsNewLocal] = useState(isNew);

    useEffect(() => {
        if (isNewLocal) {
            setIsNewLocal(true);
            onView();
        }

    }, [isNew, isNewLocal, onView, announcement.author]);

    return (
        <div className={`bg-orange-50 border-2 border-orange-100 p-2 my-4 mx-2 rounded-md shadow-md transition-all duration-300 ${isNew ? 'animate-pulse border-2 border-green-500' : ''}'`}>
            <h3>{announcement.title}</h3>
            <p>{announcement.content}</p>
            <p className="text-stone-500">From: {announcement.author_name}</p>
            <p className="text-stone-500">Expires in: {announcement.time_left}</p>
        </div>
    );
}
